import React from 'react';
import classNames from 'classnames';
import { APP_BG } from '@/constant/theme/colors.constant';

interface PageCardProps {
  /** Page content goes here (header + body) */
  children: React.ReactNode;
  /** Extra Tailwind classes on the outer card */
  className?: string;
  /** data-testid attribute */
  testId?: string;
}

/**
 * Outermost white/dark card that wraps a full detail page.
 * Provides the rounded corners, border, shadow, and scroll overflow.
 */
export const PageCard = ({
  children,
  className = '',
  testId,
}: PageCardProps) => (
  <div
    data-testid={testId ?? ''}
    className={classNames(
      `${APP_BG.base} rounded-2xl shadow-sm w-full mb-8`,
      'border border-gray-200/80 dark:border-gray-700/60',
      'transition-colors duration-300',
      className,
    )}
  >
    {children}
  </div>
);
